import { render, staticRenderFns } from "./OrticWizardStep.vue?vue&type=template&id=8ffc44ec&"
import script from "./OrticWizardStep.vue?vue&type=script&lang=js&"
export * from "./OrticWizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports